import React, { useEffect, useState } from 'react';
import { Button, Form, Spinner, Alert, Modal, ListGroup, InputGroup, Breadcrumb } from 'react-bootstrap';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { cookie } from 'utils/cookies';
import Pagination from 'components/general/Pagination';

import {
    FETCH_STATION_WISE_FORMS,
    DOWNLOAD_CHECKLIST_FORM,
    DOWNLOAD_FULL_PDF,
    STATUS_CHANGE,
    CREATE_CHECKLIST,
    DELETE_CHECKLIST_FORM,
    ASSIGN_TO_CONTRACTOR,
    ASSIGN_TO_MANAGER,
    UPDATE_STATION_DETAILS,
} from 'actions/formActions';
import { 
    IconDownload, 
    IconEdit, 
    IconEye,
    IconLoader2, 
    IconCheck, 
    IconX, 
    IconTrash, 
    IconUserPlus, 
    IconShieldCheck, 
    IconInfoCircle, 
    IconSearch,
    IconPlus,
    IconFilter,
    IconCalendar,
    IconBuildingStore,
    IconSubtask,
    IconLayoutGrid,
    IconArrowLeft,
    IconBox
} from '@tabler/icons-react';
import { FETCH_USERS } from 'actions/userActions';

const ShimmerLoader = () => {
    return (
        <div className="glass-panel shadow-sm p-4" style={{ overflow: 'hidden', background: '#fff', borderRadius: '16px' }}>
            <style dangerouslySetInnerHTML={{__html: `
                @keyframes shimmer {
                    0% {
                        background-position: -468px 0;
                    }
                    100% {
                        background-position: 468px 0;
                    }
                }
                .shimmer-element {
                    animation: shimmer 1.5s linear infinite;
                    background: linear-gradient(to right, #f1f5f9 8%, #e2e8f0 18%, #f1f5f9 33%);
                    background-size: 800px 104px;
                    position: relative;
                }
            `}} />
            <div className="table-responsive">
                <table className="table table-vcenter table-mobile-md card-table" style={{ pointerEvents: 'none', width: '100%' }}>
                    <thead style={{ background: '#f8fafc' }}>
                        <tr>
                            <th className="px-4 py-3"><div className="shimmer-element" style={{ height: '16px', width: '120px', borderRadius: '4px' }}></div></th>
                            <th className="py-3"><div className="shimmer-element" style={{ height: '16px', width: '100px', borderRadius: '4px' }}></div></th>
                            <th className="py-3"><div className="shimmer-element" style={{ height: '16px', width: '100px', borderRadius: '4px' }}></div></th>
                            <th className="py-3"><div className="shimmer-element" style={{ height: '16px', width: '100px', borderRadius: '4px' }}></div></th>
                            <th className="py-3"><div className="shimmer-element" style={{ height: '16px', width: '120px', borderRadius: '4px' }}></div></th>
                            <th className="py-3"><div className="shimmer-element" style={{ height: '16px', width: '100px', borderRadius: '4px' }}></div></th>
                            <th className="py-3"><div className="shimmer-element" style={{ height: '16px', width: '80px', borderRadius: '4px' }}></div></th>
                        </tr>
                    </thead>
                    <tbody>
                        {[1, 2, 3, 4, 5].map((i) => (
                            <tr key={i}>
                                <td className="px-4 py-4">
                                    <div className="d-flex align-items-center gap-3">
                                        <div className="shimmer-element" style={{ width: '40px', height: '40px', borderRadius: '10px', flexShrink: 0 }}></div>
                                        <div className="flex-grow-1">
                                            <div className="shimmer-element mb-2" style={{ height: '18px', width: '180px', borderRadius: '4px' }}></div>
                                            <div className="shimmer-element" style={{ height: '13px', width: '120px', borderRadius: '4px' }}></div>
                                        </div>
                                    </div>
                                </td>
                                <td className="py-4">
                                    <div className="shimmer-element" style={{ height: '24px', width: '90px', borderRadius: '20px' }}></div>
                                </td>
                                <td className="py-4">
                                    <div className="shimmer-element mb-2" style={{ height: '16px', width: '80px', borderRadius: '4px' }}></div>
                                    <div className="shimmer-element" style={{ height: '12px', width: '60px', borderRadius: '4px' }}></div>
                                </td>
                                <td className="py-4">
                                    <div className="shimmer-element mb-2" style={{ height: '16px', width: '80px', borderRadius: '4px' }}></div>
                                    <div className="shimmer-element" style={{ height: '12px', width: '60px', borderRadius: '4px' }}></div>
                                </td>
                                <td className="py-4">
                                    <div className="shimmer-element" style={{ height: '16px', width: '110px', borderRadius: '4px' }}></div>
                                </td>
                                <td className="py-4">
                                    <div className="shimmer-element" style={{ height: '14px', width: '100px', borderRadius: '4px' }}></div>
                                </td>
                                <td className="py-4">
                                    <div className="d-flex gap-2 justify-content-end">
                                        <div className="shimmer-element" style={{ width: '32px', height: '32px', borderRadius: '8px' }}></div>
                                        <div className="shimmer-element" style={{ width: '32px', height: '32px', borderRadius: '8px' }}></div>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

const isQualityPending = (f) => {
    if (!f || typeof f !== 'object') return false;
    const s = (f.status || '').toLowerCase();
    const s1 = (f.l1?.status || '').toLowerCase();
    const s2 = (f.l2?.status || '').toLowerCase();
    return s === 'quality' || s.includes('quality') || s1 === 'quality' || s1.includes('quality') || s2 === 'quality' || s2.includes('quality');
};

const isManagerPending = (f) => {
    if (!f || typeof f !== 'object') return false;
    const s = (f.status || '').toLowerCase();
    const s1 = (f.l1?.status || '').toLowerCase();
    const s2 = (f.l2?.status || '').toLowerCase();
    return s === 'manager' || s === 'pending_manager' || s === 'pending' || s === 'submitted' || s1.includes('manager') || s2.includes('manager');
};

const isContractorPending = (f) => {
    if (!f || typeof f !== 'object') return false;
    const s = (f.status || '').toLowerCase();
    const s1 = (f.l1?.status || '').toLowerCase();
    const s2 = (f.l2?.status || '').toLowerCase();
    return s === 'contractor' || s1 === 'contractor' || s2 === 'contractor';
};

const isFormDoneByUser = (f, user, currentRole) => {
    if (!f || typeof f !== 'object') return false;
    const role = (currentRole || user?.role || cookie.get('user-role') || '').toLowerCase();
    const userId = user?.id || user?._id || cookie.get('user-id') || '';
    const rawUserName = (user?.name || cookie.get('user-name') || '').trim().toLowerCase();
    const rawUserFullName = (user?.name ? `${user.name} ${user?.lastName || ''}`.trim() : '').toLowerCase();

    const matchesName = (targetName) => {
        if (!targetName || typeof targetName !== 'string') return false;
        const t = targetName.trim().toLowerCase();
        if (!t) return false;
        if (rawUserName && (t === rawUserName || t.includes(rawUserName) || rawUserName.includes(t))) return true;
        if (rawUserFullName && (t === rawUserFullName || t.includes(rawUserFullName) || rawUserFullName.includes(t))) return true;
        return false;
    };

    const s = (f.status || '').toLowerCase();
    const s1 = (f.l1?.status || '').toLowerCase();
    const s2 = (f.l2?.status || '').toLowerCase();

    if (role === 'quality') {
        const hasQualitySig = Boolean(
            f.comments?.quality?.signature || 
            f.l1?.comments?.quality?.signature || 
            f.l2?.comments?.quality?.signature
        );
        const qualityName = f.comments?.quality?.name || f.l1?.comments?.quality?.name || f.l2?.comments?.quality?.name;
        const isApproved = s === 'approved' || s === 'completed' || s1 === 'approved' || s2 === 'approved';
        
        if (matchesName(qualityName)) return true;
        if (userId && (f.qualityId === userId || f.l1?.qualityId === userId || f.l2?.qualityId === userId)) return true;
        if (isApproved && (hasQualitySig || !qualityName)) return true;
        return false;
    }

    if (role === 'manager') {
        const hasManagerSig = Boolean(
            f.comments?.manager?.signature || 
            f.comments?.charge_engineer?.signature || 
            f.l1?.comments?.charge_engineer?.signature || 
            f.l2?.comments?.charge_engineer?.signature
        );
        const managerName = f.comments?.manager?.name || f.comments?.charge_engineer?.name || f.l1?.comments?.charge_engineer?.name || f.l2?.comments?.charge_engineer?.name;
        const isManagerActed = f.manager_approve || s === 'manager_approved' || s === 'quality' || s === 'approved' || s1 === 'quality' || s1 === 'approved' || s2 === 'quality' || s2 === 'approved';
        
        if (userId && (f.managerId === userId || f.l1?.managerId === userId || f.l2?.managerId === userId)) {
            return isManagerActed || hasManagerSig;
        }
        if (matchesName(managerName)) return true;
        if (isManagerActed && hasManagerSig) return true;
        return false;
    }

    if (role === 'engineer') {
        if (matchesName(f.userName)) return true;
        if (userId && f.userId === userId) return true;
        const engineerName = f.comments?.engineer?.name || f.comments?.charge_engineer?.name || f.l1?.comments?.charge_engineer?.name || f.l2?.comments?.charge_engineer?.name;
        if (matchesName(engineerName)) return true;
        return false;
    }

    if (role === 'contractor') {
        const hasContractorSig = Boolean(
            f.comments?.contractor?.signature || 
            f.l1?.comments?.contractor?.signature || 
            f.l2?.comments?.contractor?.signature
        );
        const contractorName = f.comments?.contractor?.name || f.l1?.comments?.contractor?.name || f.l2?.comments?.contractor?.name;
        if (matchesName(contractorName)) return true;
        if (userId && (f.contractorId === userId || f.l1?.contractorId === userId || f.l2?.contractorId === userId)) {
            return hasContractorSig || s !== 'draft';
        }
        return false;
    }

    if (role === 'operations' || role === 'operation') {
        const opsStatus = (f.operations_status || '').toLowerCase();
        const hasOpsSig = Boolean(f.comments?.operations?.signature);
        const opsName = f.comments?.operations?.name;
        if (matchesName(opsName)) return true;
        return opsStatus === 'approved' || hasOpsSig;
    }

    if (role === 'maintenance') {
        const maintStatus = (f.maintenance_status || '').toLowerCase();
        const hasMaintSig = Boolean(f.comments?.maintenance?.signature);
        const maintName = f.comments?.maintenance?.name;
        if (matchesName(maintName)) return true;
        return maintStatus === 'approved' || hasMaintSig;
    }

    if (role === 'admin') {
        return s === 'approved' || s === 'completed' || s1 === 'approved' || s2 === 'approved';
    }

    return false;
};

const StationForms = () => {
    const { stationId } = useParams();
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {
        loading,
        stationwiseformslist = [],
        downloadLoading,
        error,
        statusLoading,
        deleteLoading,
    } = useSelector((state) => state.checklist);
    const authUser = useSelector((state) => state.auth?.user?.user || state.auth?.user);
    const userRole = (authUser?.role || cookie.get('user-role') || '').toLowerCase();

    const { users } = useSelector((state) => state.users);

    const contractors =
        Array.isArray(users)
            ? users.filter((u) => (u?.role || '').toLowerCase() === 'contractor')
            : [];

    const managers =
        Array.isArray(users)
            ? users.filter((u) => (u?.role || '').toLowerCase() === 'manager')
            : [];





    const [search, setSearch] = useState('');
    const [formFilter, setFormFilter] = useState('');
    const [downloadInProgress, setDownloadInProgress] = useState(null);
    const [statusChangeInProgress, setStatusChangeInProgress] = useState(null);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [statusFilter, setStatusFilter] = useState(location.state?.fromTab === 'my_items' ? 'ApprovedByYou' : '');
    const [userFilter, setUserFilter] = useState('');
    const [showStatusModal, setShowStatusModal] = useState(false);
    const [selectedFormId, setSelectedFormId] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState('');
    const [formName, setFormName] = useState('');
    const [showAddFormsModal, setShowAddFormsModal] = useState(false);
    const [quantities, setQuantities] = useState({});
    const [addFormError, setAddFormError] = useState('');
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteInProgress, setDeleteInProgress] = useState(null);
    const [deleteConfirmInput, setDeleteConfirmInput] = useState('');

    // ✅ Contractor modal state (RESTORING)
    const [showContractorModal, setShowContractorModal] = useState(false);
    const [contractorLevel, setContractorLevel] = useState(null);
    const [selectedContractorId, setSelectedContractorId] = useState('');
    const [assignInProgress, setAssignInProgress] = useState(false);
    const [showManagerModal, setShowManagerModal] = useState(false);
    const [managerLevel, setManagerLevel] = useState(null);
    const [selectedManagerId, setSelectedManagerId] = useState('');
    const [managerAssignInProgress, setManagerAssignInProgress] = useState(false);

    // Edit Station Details state
    const [showEditStationModal, setShowEditStationModal] = useState(false);
    const [editStationId, setEditStationId] = useState('');
    const [editStationName, setEditStationName] = useState('');
    const [editStationLoading, setEditStationLoading] = useState(false);
    const [editStationError, setEditStationError] = useState('');

    const handleOpenEditStationModal = () => {
        setEditStationId(stationId || '');
        setEditStationName(stationwiseformslist?.[0]?.project_name || '');
        setEditStationError('');
        setShowEditStationModal(true);
    };

    const handleSaveStationDetails = () => {
        const trimmedNewStationId = editStationId.trim();
        const trimmedNewProjectName = editStationName.trim();

        if (!trimmedNewStationId) {
            setEditStationError('Station ID cannot be empty.');
            return;
        }
        if (!trimmedNewProjectName) {
            setEditStationError('Station Name cannot be empty.');
            return;
        }

        setEditStationLoading(true);
        setEditStationError('');

        dispatch({
            type: UPDATE_STATION_DETAILS,
            payload: {
                stationId,
                data: {
                    newStationId: trimmedNewStationId,
                    project_name: trimmedNewProjectName,
                },
            },
            cb: (err) => {
                setEditStationLoading(false);
                if (err) {
                    setEditStationError(err.message || 'Failed to update station details');
                } else {
                    toast.success('Station details updated successfully');
                    setShowEditStationModal(false);
                    if (trimmedNewStationId !== stationId) {
                        navigate(`/formList/${encodeURIComponent(trimmedNewStationId)}`, { replace: true });
                    } else {
                        dispatch({ type: FETCH_STATION_WISE_FORMS, payload: stationId });
                    }
                }
            },
        });
    };


    const [isSearchExpanded, setIsSearchExpanded] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const limit = 10;

    const clearFilters = () => {
        setSearch('');
        setFormFilter('');
        setStatusFilter('');
        setUserFilter('');
        setStartDate('');
        setEndDate('');
        setCurrentPage(1);
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [search, formFilter, statusFilter, userFilter, startDate, endDate]);

    // RESTORED contractor functions
    const openContractorModal = (form, level /* 'l1' | 'l2' | 'root' */) => {
        setSelectedFormId(form._id);
        setFormName(form.formName);
        setContractorLevel(level);
        setSelectedContractorId('');
        setShowContractorModal(true);

        dispatch({
            type: FETCH_USERS,
            payload: { role: 'contractor', limit: 100, page: 1 },
        });
    };

    const handleAssignToContractor = () => {
        if (!selectedContractorId) {
            toast.error('Please select a contractor');
            return;
        }
        setAssignInProgress(true);
        dispatch({
            type: ASSIGN_TO_CONTRACTOR,
            payload: {
                formId: selectedFormId,
                formName,
                level: contractorLevel, // 'l1' | 'l2' | 'root'
                contractorId: selectedContractorId,
                stationId,
            },
            cb: (res) => {
                setAssignInProgress(false);
                if (res?.status === 200) {
                    toast.success('Assigned to contractor');
                    setShowContractorModal(false);
                    fetchStationWiseForms();
                } else {
                    toast.error(res?.data?.message || 'Failed to assign');
                }
            },
        });
    };
    const openManagerModal = (form, level /* 'l1' | 'l2' | 'root' */) => {
        setSelectedFormId(form._id);
        setFormName(form.formName);
        setManagerLevel(level);
        setSelectedManagerId('');
        setShowManagerModal(true);

        dispatch({
            type: FETCH_USERS,
            payload: { role: 'manager', limit: 100, page: 1 },
        });
    };

    const handleAssignToManager = () => {
        if (!selectedManagerId) {
            toast.error('Please select a manager');
            return;
        }
        setManagerAssignInProgress(true);
        dispatch({
            type: ASSIGN_TO_MANAGER,
            payload: {
                formId: selectedFormId,
                formName,
                level: managerLevel,
                managerId: selectedManagerId,
                stationId,
            },
            cb: (res) => {
                setManagerAssignInProgress(false);
                if (res?.status === 200) {
                    toast.success('Assigned to manager');
                    setShowManagerModal(false);
                    fetchStationWiseForms();
                } else {
                    toast.error(res?.data?.message || 'Failed to assign');
                }
            },
        });
    };

    const formNameToComponent = {
        commissioning: 'CommissioningForm',
        db_panel: 'DBPanelForm',
        apfc_panel: 'APFCPanelForm',
        cabel_tray: 'CabelTrayForm',
        earthing: 'EarthingForm',
        ht_cable: 'HTCableForm',
        lightning_arrester: 'LightningArresterForm',
        lt_cable: 'LTCableForm',
        lt_panel: 'LTPanelForm',
        transformer: 'TransformerForm',
        vcb: 'VCBForm',
        hoto: 'HOTOForm',
        canopy: 'CanopyForm',
    };

    const checklistItems = [
        'APFC Panel',
        'Cabel Tray',
        'DB Panel',
        'Earthing',
        'HT Cabel',
        'Lightning Arrester',
        'LT Cabel',
        'LT Panel',
        'Transformer',
        'VCB',
        'HOTO (Project Handover Takeover Report)',
        'Canopy',
    ];

    const formNames = Object.keys(formNameToComponent);

    const prettifyFormName = (name = '', form = null) => {
        if (name === 'commissioning' || name === 'commissioning_report' || form?.isCommissioningForm) {
            const ocppId = (form?.chargerId || form?.documentNo?.replace(/^NET\s*\/\s*I&C\s*\//i, '') || '').trim();
            return ocppId ? `COMMISSIONING REPORT (${ocppId})` : 'COMMISSIONING REPORT';
        }
        return String(name).replace(/\(.*?\)/g, '').replace(/_/g, ' ').trim().toUpperCase();
    };

    const handleFormClick = (form) => {
        if (form?.isCommissioningForm || form?.formName === 'commissioning') {
            const filerId = form?.submittedBy?._id || form?.submittedBy?.id || form?.submittedBy;
            const mgrId = form?.reportingTo?._id || form?.reportingTo?.id || form?.reportingTo;
            const myId = authUser?.id || authUser?._id;
            if ((form?.status === 'draft' || form?.status === 'rework') && filerId === myId) {
                navigate(`/allForms/form/edit/${form._id}`);
            } else if (form?.status === 'pending' && mgrId === myId) {
                navigate(`/allForms/form/review/${form._id}`);
            } else {
                navigate(`/allForms/form/view/${form._id}`);
            }
        } else {
            navigate(`/formList/${stationId}/${form?.formName}/${form._id}`);
        }
    };

    const statusLabel = (status = '', form = null, level = null) => {
        const s = (status || '').toLowerCase();
        switch (s) {
            case 'approved':
                return 'APPROVED';
            case 'rejected':
                return 'REJECTED';
            case 're-work':
            case 'rework':
                return 'RE-WORK';
            case 'submitted':
                return 'SUBMITTED';
            case 'manager_approved':
                return 'MANAGER APPROVED';
            case 'draft':
                return 'DRAFT';
            case 'contractor':
                if (level && form && form[level]?.managerId) return 'PENDING: CONT. & MGR.';
                if (!level && form && form.managerId) return 'PENDING: CONT. & MGR.';
                return 'PENDING FROM CONTRACTOR';
            case 'quality':
                return 'PENDING FROM QUALITY';
            case 'manager':
            case 'pending_manager':
            case 'pending from manager':
            case 'pending_from_manager':
                return 'PENDING FROM MANAGER';
            case 'pending':
                if (level === 'l1') return 'PENDING FROM MANAGER';
                if (level === 'l2') return 'PENDING FROM QUALITY';
                // Global inference
                if (form) {
                    if (form.l2 && (form.l2.status || '').toLowerCase() === 'pending') return 'PENDING FROM QUALITY';
                    if (form.l1 && (form.l1.status || '').toLowerCase() === 'pending') return 'PENDING FROM MANAGER';
                    if (form.managerId && (form.status || '').toLowerCase() === 'pending_manager') return 'PENDING FROM MANAGER';
                    if ((form.l1?.status || '').toLowerCase() === 'contractor' || (form.l2?.status || '').toLowerCase() === 'contractor') return 'PENDING FROM CONTRACTOR';
                }
                return 'PENDING';
            default:
                return (status || 'N/A').toUpperCase();
        }
    };


    const fetchStationWiseForms = () => {
        if (stationId) {
            dispatch({ type: FETCH_STATION_WISE_FORMS, payload: stationId });
        }
    };

    useEffect(() => {
        fetchStationWiseForms();
        setQuantities(checklistItems.reduce((acc, item) => ({ ...acc, [item]: 0 }), {}));
    }, [dispatch, stationId, statusLoading]); // keep your existing deps

    const initiateStatusChange = (formId, formName, newStatus) => {
        setSelectedFormId(formId);
        setSelectedStatus(newStatus);
        setFormName(formName);
        setShowStatusModal(true);
    };

    const handleStatusChange = () => {
        if (selectedFormId) {
            setStatusChangeInProgress(selectedFormId);
            dispatch({
                type: STATUS_CHANGE,
                payload: { formId: selectedFormId, status: selectedStatus, formName },
            });
            if (statusLoading) {
                setStatusChangeInProgress(null);
                toast.success(`Form status changed to ${selectedStatus}`);
                setShowStatusModal(false);
            }
        }
    };

    const initiateDeleteForm = (formId, formName) => {
        setSelectedFormId(formId);
        setFormName(formName);
        setDeleteConfirmInput('');
        setShowDeleteModal(true);
    };

    const handleDeleteForm = () => {
        if (selectedFormId && deleteConfirmInput === 'DELETE') {
            setDeleteInProgress(selectedFormId);
            dispatch({
                type: DELETE_CHECKLIST_FORM,
                payload: { formId: selectedFormId, formName },
            });
            setDeleteConfirmInput('');
            if (!deleteLoading) {
                fetchStationWiseForms({});
                setShowDeleteModal(false);
            }
        }
    };

    const handleCloseStatusModal = () => {
        setShowStatusModal(false);
        setSelectedFormId(null);
        setSelectedStatus('');
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
        setSelectedFormId(null);
        setFormName('');
        setDeleteConfirmInput('');
    };

    const handleAddFormsModalOpen = () => {
        setShowAddFormsModal(true);
        setAddFormError('');
    };

    const handleAddFormsModalClose = () => {
        setShowAddFormsModal(false);
        setQuantities(checklistItems.reduce((acc, item) => ({ ...acc, [item]: 0 }), {}));
        setAddFormError('');
    };

    const handleQuantityChange = (item, value) => {
        const qty = parseInt(value, 10) || 0;
        setQuantities((prev) => ({ ...prev, [item]: qty }));
        if (addFormError) setAddFormError('');
    };

    const adjustQuantity = (item, delta) => {
        setQuantities((prev) => {
            const updated = Math.max(0, (prev[item] || 0) + delta);
            return { ...prev, [item]: updated };
        });
    };

    const validateAddForms = () => {
        const totalSelected = Object.values(quantities).reduce((sum, qty) => sum + (qty > 0 ? 1 : 0), 0);
        if (totalSelected === 0) {
            setAddFormError('Select at least one form with quantity greater than 0.');
            return false;
        }
        return true;
    };

    const handleAddFormsSubmit = () => {
        if (!validateAddForms()) return;

        const checklist = {};
        Object.entries(quantities).forEach(([item, quantity]) => {
            if (quantity > 0) {
                const key = item
                    .toLowerCase()
                    .replace(/\(.*?\)/g, '')
                    .replace(/[^a-z0-9]+/g, '_')
                    .replace(/^_|_$/g, '');
                checklist[key] = quantity;
            }
        });

        const payload = {
            stationId: stationId.toUpperCase(),
            project_name: stationwiseformslist[0]?.project_name || 'Unknown',
            checklist,
            is_existing_station: true,
        };

        dispatch({
            type: CREATE_CHECKLIST,
            payload,
            cb: (res) => {
                if (res.status === 200) {
                    toast.success('Forms added successfully');
                    fetchStationWiseForms();
                    handleAddFormsModalClose();
                } else {
                    setAddFormError(res.data?.message || 'Failed to add forms');
                }
            },
        });
    };

    useEffect(() => {
        if (!downloadLoading) {
            setDownloadInProgress(null);
        }
    }, [downloadLoading]);

    const filteredForms = Array.isArray(stationwiseformslist)
        ? stationwiseformslist.filter((f) => {
            if (!f || typeof f !== 'object') return false;

            // All roles can view all forms under the station/project

            const ocppId = (f.chargerId || f.documentNo?.replace(/^NET\s*\/\s*I&C\s*\//i, '') || '').toLowerCase();
            const formNameMatch =
                f.formName?.toLowerCase().includes(search.toLowerCase()) ||
                ocppId.includes(search.toLowerCase()) ||
                f.userName?.toLowerCase().includes(search.toLowerCase());

            const formFilterMatch = !formFilter || f.formName?.toLowerCase() === formFilter.toLowerCase();

            const statusMatch = !statusFilter || (
                statusFilter === 'Approved' ? (f.status || '').toLowerCase() === 'approved' :
                statusFilter === 'ApprovedByYou' || statusFilter === 'MyItems' ? isFormDoneByUser(f, authUser, userRole) :
                statusFilter === 'Pending' ? ((f.status || '').toLowerCase() !== 'approved' && (f.status || '').toLowerCase() !== 'draft') :
                statusFilter === 'Draft' ? (f.status || '').toLowerCase() === 'draft' :
                statusFilter === 'Contractor' ? isContractorPending(f) :
                statusFilter === 'Manager' ? isManagerPending(f) :
                statusFilter === 'Quality' ? isQualityPending(f) :
                (f.status || '').toLowerCase() === statusFilter.toLowerCase()
            );

            const userMatch = !userFilter || f.userName === userFilter;

            const formDate = new Date(f.createdAt);
            const start = startDate ? new Date(startDate) : null;
            const end = endDate ? new Date(endDate) : null;

            const dateInRange =
                (!start || formDate >= start) && (!end || formDate <= new Date(end.setHours(23, 59, 59, 999)));

            return formNameMatch && formFilterMatch && statusMatch && userMatch && dateInRange;
        })
        : [];

    const sortedForms = [...filteredForms].sort((a, b) => {
        const aTime = a?.updatedAt ? new Date(a.updatedAt).getTime() : 0;
        const bTime = b?.updatedAt ? new Date(b.updatedAt).getTime() : 0;
        return bTime - aTime;
    });

    const totalFormsCount = sortedForms.length;
    const totalPagesCount = Math.ceil(totalFormsCount / limit) || 1;
    const paginatedSortedForms = sortedForms.slice((currentPage - 1) * limit, (currentPage - 1) * limit + limit);

    const handlePageClick = ({ selected }) => {
        setCurrentPage(selected + 1);
    };

    const uniqueUsers = Array.from(new Set(stationwiseformslist.map(f => f.userName).filter(Boolean))).sort();

    const stationForms = Array.isArray(stationwiseformslist) ? stationwiseformslist : [];
    const totalFormsCountAll = stationForms.length;
    const totalApprovedCount = stationForms.filter(f => (f?.status || '').toLowerCase() === 'approved').length;
    const totalDraftCount = stationForms.filter(f => (f?.status || '').toLowerCase() === 'draft').length;
    const totalPendingCount = totalFormsCountAll - totalApprovedCount - totalDraftCount;
    const totalQualityPendingCount = stationForms.filter(isQualityPending).length;
    const totalManagerPendingCount = stationForms.filter(isManagerPending).length;
    const totalContractorPendingCount = stationForms.filter(isContractorPending).length;
    const totalMyApprovedCount = stationForms.filter(f => isFormDoneByUser(f, authUser, userRole)).length;

    const stationStatCards = [
        { label: 'Total Forms', value: totalFormsCountAll, icon: <IconLayoutGrid size={14} />, iconColor: '#475569', iconBg: '#f1f5f9', filterKey: '' },
        { label: 'Approved', value: totalApprovedCount, icon: <IconCheck size={14} />, iconColor: '#16a34a', iconBg: '#dcfce7', filterKey: 'Approved' },
        { label: 'Approved by You', value: totalMyApprovedCount, icon: <IconCheck size={14} />, iconColor: '#059669', iconBg: '#d1fae5', filterKey: 'ApprovedByYou' },
        { label: 'Total Pending', value: totalPendingCount, icon: <IconInfoCircle size={14} />, iconColor: '#ea580c', iconBg: '#ffedd5', filterKey: 'Pending' },
        { label: 'Draft', value: totalDraftCount, icon: <IconSubtask size={14} />, iconColor: '#2563eb', iconBg: '#dbeafe', filterKey: 'Draft' },
        { label: 'Pending Quality', value: totalQualityPendingCount, icon: <IconShieldCheck size={14} />, iconColor: '#e11d48', iconBg: '#ffe4e6', filterKey: 'Quality' },
        { label: 'Pending Manager', value: totalManagerPendingCount, icon: <IconUserPlus size={14} />, iconColor: '#0284c7', iconBg: '#e0f2fe', filterKey: 'Manager' },
        { label: 'Pending Contractor', value: totalContractorPendingCount, icon: <IconUserPlus size={14} />, iconColor: '#9333ea', iconBg: '#f3e8ff', filterKey: 'Contractor' },
    ];

    const handleDownload = (formId, formName, userName) => {
        if (formId) {
            setDownloadInProgress(formId);
            dispatch({
                type: DOWNLOAD_CHECKLIST_FORM,
                payload: { formId, formName, userName, stationId },
                meta: { formId },
            });
        }
    };

    const handleDownloadFullPDF = () => {
        dispatch({
            type: DOWNLOAD_FULL_PDF,
            payload: { stationId }
        });
    };

    const formatToIST = (utcDate) => {
        if (!utcDate) return 'N/A';
        const date = new Date(utcDate);
        return date.toLocaleString('en-IN', {
            timeZone: 'Asia/Kolkata',
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
        });
    };

    return (
        <div className="page-body">
            <div className="container-xl premium-dashboard-stats">
                {/* Breadcrumbs */}
                <Breadcrumb className="mb-2" style={{ fontSize: '13px' }}>
                    <Breadcrumb.Item href="#" onClick={() => navigate('/formList')}>Project Hub</Breadcrumb.Item>
                    <Breadcrumb.Item active>Station Hub: {stationId}</Breadcrumb.Item>
                </Breadcrumb>

                {/* Compact Station Context Header */}
                <div className="station-hub-header shadow-sm py-3 px-4 mb-3">
                    <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                        <div className="d-flex align-items-center gap-3">
                            <div style={{
                                width: '42px', height: '42px', borderRadius: '12px',
                                background: '#eff6ff', color: '#2563eb',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                flexShrink: 0
                            }}>
                                <IconBuildingStore size={22} />
                            </div>
                            <div>
                                <div className="d-flex align-items-center gap-2 flex-wrap">
                                    <h3 className="m-0 fw-bold" style={{ fontSize: '18px', color: '#0f172a', letterSpacing: '-0.3px' }}>
                                        {stationwiseformslist?.[0]?.project_name || 'PROJECT NAME'}
                                    </h3>
                                    <span className="badge bg-primary-lt" style={{ fontSize: '11px', padding: '3px 8px' }}>
                                        ID: {stationId}
                                    </span>
                                    {(userRole === 'admin' || userRole === 'engineer' || userRole === 'manager') && (
                                        <button
                                            className="btn btn-sm btn-link p-0 text-primary border-0 d-inline-flex align-items-center ms-1"
                                            onClick={handleOpenEditStationModal}
                                            title="Edit Station ID & Name"
                                            style={{ fontSize: '12px', textDecoration: 'none', fontWeight: 600 }}
                                        >
                                            <IconEdit size={14} className="me-1" /> Edit
                                        </button>
                                    )}
                                </div>
                                <div className="d-flex align-items-center gap-3 mt-1 text-muted" style={{ fontSize: '12px' }}>
                                    <span>Total Submissions: <strong className="text-dark">{stationwiseformslist.length}</strong></span>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex align-items-center gap-2">
                            {(userRole === 'admin' || userRole === 'engineer' || userRole === 'manager') && (
                                <Button 
                                    size="sm"
                                    className="px-3 py-2 border-0 shadow-sm d-flex align-items-center gap-1 fw-bold"
                                    style={{ background: '#2563eb', borderRadius: '8px', fontSize: '13px' }}
                                    onClick={handleAddFormsModalOpen}
                                >
                                    <IconPlus size={16} /> Add Checklist Forms
                                </Button>
                            )}
                            {stationwiseformslist.length > 0 && (
                                <Button 
                                    size="sm"
                                    className="px-3 py-2 border-0 shadow-sm d-flex align-items-center gap-1 fw-bold"
                                    style={{ background: '#16a34a', color: '#fff', borderRadius: '8px', fontSize: '13px' }}
                                    onClick={handleDownloadFullPDF}
                                    disabled={downloadLoading}
                                >
                                    {downloadLoading ? (
                                        <>
                                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />
                                            Generating...
                                        </>
                                    ) : (
                                        <>
                                            <IconDownload size={16} /> Download Full PDF
                                        </>
                                    )}
                                </Button>
                            )}
                            <Button 
                                variant="outline-secondary" 
                                size="sm"
                                className="px-3 py-2 border-0 shadow-sm d-flex align-items-center gap-1 fw-semibold"
                                style={{ borderRadius: '8px', fontSize: '13px', background: '#f8fafc', color: '#64748b' }}
                                onClick={() => navigate('/formList')}
                            >
                                <IconArrowLeft size={16} /> Back
                            </Button>
                        </div>
                    </div>
                </div>

                {/* Compact Stat Cards Grid */}
                <div className="row g-2 mb-3 mt-3">
                    {stationStatCards.map((card) => {
                        const isSelected = card.filterKey === '' 
                            ? !statusFilter 
                            : (statusFilter || '').toLowerCase() === card.filterKey.toLowerCase();
                        return (
                            <div className="col-6 col-sm-4 col-md-3 col-xl" key={card.label}>
                                <div 
                                    onClick={() => {
                                        if (card.filterKey === '') {
                                            setStatusFilter('');
                                        } else {
                                            setStatusFilter(prev => (prev || '').toLowerCase() === card.filterKey.toLowerCase() ? '' : card.filterKey);
                                        }
                                    }}
                                    style={{
                                        background: isSelected ? card.iconBg : '#ffffff',
                                        border: isSelected ? `2px solid ${card.iconColor}` : '1px solid #e2e8f0',
                                        borderRadius: '12px',
                                        padding: '10px 14px',
                                        boxShadow: isSelected 
                                            ? `0 2px 8px 0 ${card.iconColor}25` 
                                            : '0 1px 2px 0 rgba(0,0,0,0.04)',
                                        transition: 'all 0.15s ease',
                                        cursor: 'pointer',
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center'
                                    }}
                                    title={isSelected ? (card.filterKey === '' ? 'All forms currently shown' : 'Click to clear filter') : `Filter by ${card.label}`}
                                >
                                    <div className="d-flex align-items-center justify-content-between mb-1">
                                        <span style={{ 
                                            color: isSelected ? card.iconColor : '#64748b', 
                                            fontSize: '11px', 
                                            fontWeight: 700, 
                                            textTransform: 'uppercase', 
                                            letterSpacing: '0.03em',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }}>
                                            {card.label}
                                        </span>
                                        <span style={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: '26px',
                                            height: '26px',
                                            borderRadius: '8px',
                                            background: isSelected ? '#ffffff' : card.iconBg,
                                            color: card.iconColor,
                                            flexShrink: 0
                                        }}>{card.icon}</span>
                                    </div>
                                    <div style={{ fontSize: '20px', fontWeight: 800, lineHeight: 1.1, color: '#0f172a' }}>
                                        {card.value}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                {/* Premium Toolbar: Filters & Search */}
                <div className="premium-toolbar shadow-sm">
                    <div className="d-flex flex-wrap align-items-center gap-3 flex-grow-1">
                        <div className={`search-container ${isSearchExpanded ? 'expanded' : ''}`} style={{ maxWidth: '300px' }}>
                            <InputGroup className="premium-input-group shadow-sm" style={{ background: '#fff', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                                <InputGroup.Text className="bg-transparent border-0 pe-0">
                                    <IconSearch size={18} className="text-muted" />
                                </InputGroup.Text>
                                <Form.Control
                                    className="border-0 bg-transparent py-2"
                                    placeholder="Search by ID or Filer..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    onFocus={() => setIsSearchExpanded(true)}
                                    onBlur={() => !search && setIsSearchExpanded(false)}
                                    autoComplete="off"
                                />
                            </InputGroup>
                        </div>

                        <div className="d-flex align-items-center gap-2">
                            <IconFilter size={18} className="text-muted" />
                            <Form.Select 
                                className="premium-select shadow-sm" 
                                style={{ borderRadius: '12px', border: '1px solid #e2e8f0', width: '180px' }}
                                value={formFilter}
                                onChange={(e) => setFormFilter(e.target.value)}
                            >
                                <option value="">All Form Types</option>
                                {formNames.map(f => (
                                    <option key={f} value={f}>{prettifyFormName(f)}</option>
                                ))}
                            </Form.Select>
                        </div>

                        <div className="d-flex align-items-center gap-2">
                            <Form.Select 
                                className="premium-select shadow-sm"
                                style={{ borderRadius: '12px', border: '1px solid #e2e8f0', width: '160px' }}
                                value={statusFilter}
                                onChange={(e) => setStatusFilter(e.target.value)}
                            >
                                <option value="">All Statuses</option>
                                <option value="Approved">Approved</option>
                                <option value="ApprovedByYou">Approved by You</option>
                                <option value="Pending">Pending</option>
                                <option value="Contractor">Contractor</option>
                                <option value="Manager">Manager</option>
                                <option value="Quality">Quality</option>
                                <option value="Rejected">Rejected</option>
                                <option value="Draft">Draft</option>
                            </Form.Select>
                        </div>

                        <div className="d-flex align-items-center gap-2">
                            <Form.Select 
                                className="premium-select shadow-sm"
                                style={{ borderRadius: '12px', border: '1px solid #e2e8f0', width: '160px' }}
                                value={userFilter}
                                onChange={(e) => setUserFilter(e.target.value)}
                            >
                                <option value="">All Filers</option>
                                {uniqueUsers.map(u => (
                                    <option key={u} value={u}>{u}</option>
                                ))}
                            </Form.Select>
                        </div>

                        <div className="d-flex align-items-center gap-3">
                            <div className="d-flex align-items-center gap-2">
                                <IconCalendar size={18} className="text-muted" />
                                <Form.Control 
                                    type="date" 
                                    className="premium-date shadow-sm"
                                    style={{ borderRadius: '12px', border: '1px solid #e2e8f0' }}
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                                <span className="text-muted">to</span>
                                <Form.Control 
                                    type="date" 
                                    className="premium-date shadow-sm"
                                    style={{ borderRadius: '12px', border: '1px solid #e2e8f0' }}
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                    
                    <Button variant="ghost" className="text-danger" onClick={clearFilters}>
                        Clear Filters
                    </Button>
                </div>

                {/* Forms Table */}
                {loading ? (
                    <ShimmerLoader />
                ) : error ? (
                    <Alert variant="danger" className="glass-panel text-center border-0 py-5 shadow-sm">
                        <IconX size={48} className="mb-3 text-danger" />
                        <h4 className="fw-bold text-danger">Error Loading Data</h4>
                        <p className="text-muted mb-0">{error.message || 'Failed to fetch forms. Please try again.'}</p>
                    </Alert>
                ) : (
                    <div className="glass-panel shadow-sm" style={{ overflow: 'hidden' }}>
                        <div className="table-responsive">
                            <table className="table table-vcenter table-mobile-md card-table">
                                <thead style={{ background: '#f8fafc' }}>
                                    <tr>
                                        <th className="px-4 py-3 text-muted fw-bold text-uppercase small" style={{ fontSize: '11px' }}>Form Identity</th>
                                        <th className="py-3 text-muted fw-bold text-uppercase small" style={{ fontSize: '11px' }}>Global Status</th>
                                        <th className="py-3 text-muted fw-bold text-uppercase small" style={{ fontSize: '11px' }}>L1 Workflow</th>
                                        <th className="py-3 text-muted fw-bold text-uppercase small" style={{ fontSize: '11px' }}>L2 Workflow</th>
                                        <th className="py-3 text-muted fw-bold text-uppercase small" style={{ fontSize: '11px' }}>Filer</th>
                                        <th className="py-3 text-muted fw-bold text-uppercase small" style={{ fontSize: '11px' }}>Updated</th>
                                        <th className="px-4 py-3 text-end text-muted fw-bold text-uppercase small w-1" style={{ fontSize: '11px' }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {paginatedSortedForms.length > 0 ? (
                                        paginatedSortedForms.map((form) => {
                                            const THREE_HOURS_MS = 3 * 60 * 60 * 1000;
                                            const formTime = new Date(form.createdAt || form.updatedAt || 0).getTime();
                                            const isFormRecent = formTime > 0 && (Date.now() - formTime) <= THREE_HOURS_MS;
                                            return (
                                                <tr 
                                                    key={form._id}
                                                    onClick={() => handleFormClick(form)}
                                                    style={{ 
                                                        cursor: 'pointer', 
                                                        transition: 'background-color 0.15s ease',
                                                        ...(isFormRecent ? { borderLeft: '4px solid #2563eb' } : {})
                                                    }}
                                                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f8fafc'; }}
                                                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                                                >
                                                    <td className="px-4">
                                                        <div className="d-flex align-items-center">
                                                            <div className="avatar me-3 bg-blue-lt flex-shrink-0" style={{ width: '36px', height: '36px' }}>
                                                                <IconLayoutGrid size={18} />
                                                            </div>
                                                            <div>
                                                                <div className="d-flex align-items-center gap-2 flex-wrap">
                                                                    <div className="fw-bold" style={{ color: '#1e293b', fontSize: '14px' }}>
                                                                        {prettifyFormName(form.formName, form)}
                                                                    </div>
                                                                    {isFormDoneByUser(form, authUser, userRole) && (
                                                                        <span 
                                                                            className="badge bg-green-lt d-inline-flex align-items-center gap-1"
                                                                            style={{ fontSize: '10px', padding: '2px 6px', borderRadius: '6px' }}
                                                                            title="Approved / Completed by you"
                                                                        >
                                                                            <IconCheck size={11} /> By You
                                                                        </span>
                                                                    )}
                                                                </div>
                                                                <div className="text-muted small fw-mono" style={{ fontSize: '11px' }}>ID: #{form._id.slice(-6).toUpperCase()}</div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                <td>
                                                    {form.formName === 'hoto' && (form.status === 'MANAGER_APPROVED' || (form.status || '').toLowerCase() === 'approved') ? (
                                                        (form.status || '').toLowerCase() === 'approved' ? (
                                                            <span className="badge bg-success-lt font-weight-bold py-1 px-2">APPROVED</span>
                                                        ) : (
                                                            <div className="d-flex flex-column gap-1 align-items-start">
                                                                <div className="d-flex align-items-center gap-1">
                                                                    <span className="text-muted fw-bold" style={{fontSize: '9px', minWidth: '12px'}}>M:</span>
                                                                    <span className={`badge bg-${(form.maintenance_status || 'pending') === 'approved' ? 'success' : 'warning'}-lt py-0 px-1`} style={{fontSize: '10px'}}>
                                                                        {(form.maintenance_status || 'pending').toUpperCase()}
                                                                    </span>
                                                                </div>
                                                                <div className="d-flex align-items-center gap-1">
                                                                    <span className="text-muted fw-bold" style={{fontSize: '9px', minWidth: '12px'}}>O:</span>
                                                                    <span className={`badge bg-${(form.operations_status || 'pending') === 'approved' ? 'success' : 'warning'}-lt py-0 px-1`} style={{fontSize: '10px'}}>
                                                                        {(form.operations_status || 'pending').toUpperCase()}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        )
                                                    ) : (
                                                        <div className="d-flex align-items-center gap-2">
                                                            <span className={`badge ${
                                                                (form.status || '').toLowerCase() === 'approved' ? 'bg-success-lt font-weight-bold' :
                                                                (form.status || '').toLowerCase().includes('pending') ? 'bg-warning-lt' :
                                                                (form.status || '').toLowerCase().includes('contractor') ? 'bg-orange-lt' :
                                                                (form.status || '').toLowerCase().includes('quality') ? 'bg-purple-lt' :
                                                                'bg-secondary-lt'
                                                            } py-1 px-2`}>
                                                                {statusLabel(form.status, form)}
                                                            </span>
                                                            {!form.l1 && !form.l2 && form.formName !== 'hoto' && userRole === 'engineer' && (
                                                                <div className="d-flex align-items-center gap-2">
                                                                    {(form.status || '').toLowerCase() === 'contractor' && (
                                                                        <button 
                                                                            className="btn-link p-0 border-0 bg-transparent text-primary d-flex" 
                                                                            title={form.contractorId ? "View Contractor" : "Assign Contractor"}
                                                                            onClick={(e) => { e.stopPropagation(); openContractorModal(form, 'root'); }}
                                                                        >
                                                                            {form.contractorId ? <IconInfoCircle size={14} /> : <IconUserPlus size={14} />}
                                                                        </button>
                                                                    )}
                                                                    {(form.status || '').toLowerCase().includes('manager') && (
                                                                        <button 
                                                                            className="btn-link p-0 border-0 bg-transparent text-success d-flex" 
                                                                            title={form.managerId ? "View Manager" : "Assign Manager"}
                                                                            onClick={(e) => { e.stopPropagation(); openManagerModal(form, 'root'); }}
                                                                        >
                                                                            {form.managerId ? <IconInfoCircle size={14} /> : <IconShieldCheck size={14} />}
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </td>
                                                <td>
                                                    {(form.l1 || form.formName === 'hoto') ? (
                                                        <div className="d-flex align-items-center gap-2">
                                                            <span className={`badge bg-${( (form.l1?.status || form.status) || '').toLowerCase() === 'approved' ? 'success' : 'azure'}-lt`}>
                                                                {form.formName === 'hoto' ? statusLabel(form.status, form) : statusLabel(form.l1?.status, form, 'l1')}
                                                            </span>
                                                            {/* HOTO Manager Assignment */}
                                                            {form.formName === 'hoto' && userRole === 'engineer' && (form.status === 'SUBMITTED' || (form.status || '').toLowerCase().includes('manager')) && (
                                                                <button 
                                                                    className="btn-link p-0 border-0 bg-transparent text-success d-flex" 
                                                                    title={form.managerId ? "View Manager" : "Assign Manager"}
                                                                    onClick={(e) => { e.stopPropagation(); openManagerModal(form, 'root'); }}
                                                                >
                                                                    {form.managerId ? <IconInfoCircle size={14} /> : <IconShieldCheck size={14} />}
                                                                </button>
                                                            )}
                                                            {/* Standard L1/L2 logic */}
                                                            {form.l1 && userRole === 'engineer' && (form.l1.status || '').toLowerCase() === 'contractor' && (
                                                                <button 
                                                                    className="btn-link p-0 border-0 bg-transparent text-primary d-flex" 
                                                                    title={form.l1.contractorId ? "View Contractor" : "Assign Contractor"}
                                                                    onClick={(e) => { e.stopPropagation(); openContractorModal(form, 'l1'); }}
                                                                >
                                                                    {form.l1.contractorId ? <IconInfoCircle size={14} /> : <IconUserPlus size={14} />}
                                                                </button>
                                                            )}
                                                            {form.l1 && userRole === 'engineer' && (form.l1.status || '').toLowerCase().includes('manager') && (
                                                                <button 
                                                                    className="btn-link p-0 border-0 bg-transparent text-success d-flex" 
                                                                    title={form.l1.managerId ? "View Manager" : "Assign Manager"}
                                                                    onClick={(e) => { e.stopPropagation(); openManagerModal(form, 'l1'); }}
                                                                >
                                                                    {form.l1.managerId ? <IconInfoCircle size={14} /> : <IconShieldCheck size={14} />}
                                                                </button>
                                                            )}
                                                        </div>
                                                    ) : <span className="text-muted small">—</span>}
                                                </td>
                                                <td>
                                                    {form.l2 ? (
                                                        <div className="d-flex align-items-center gap-2">
                                                            <span className={`badge bg-${(form.l2.status || '').toLowerCase() === 'approved' ? 'success' : 'purple'}-lt`}>
                                                                {statusLabel(form.l2.status, form, 'l2')}
                                                            </span>
                                                            {userRole === 'engineer' && (form.l2.status || '').toLowerCase() === 'contractor' && (
                                                                <button 
                                                                    className="btn-link p-0 border-0 bg-transparent text-primary d-flex" 
                                                                    title={form.l2.contractorId ? "View Contractor" : "Assign Contractor"}
                                                                    onClick={(e) => { e.stopPropagation(); openContractorModal(form, 'l2'); }}
                                                                >
                                                                    {form.l2.contractorId ? <IconInfoCircle size={14} /> : <IconUserPlus size={14} />}
                                                                </button>
                                                            )}
                                                            {userRole === 'engineer' && (form.l2.status || '').toLowerCase().includes('manager') && (
                                                                <button 
                                                                    className="btn-link p-0 border-0 bg-transparent text-success d-flex" 
                                                                    title={form.l2.managerId ? "View Manager" : "Assign Manager"}
                                                                    onClick={(e) => { e.stopPropagation(); openManagerModal(form, 'l2'); }}
                                                                >
                                                                    {form.l2.managerId ? <IconInfoCircle size={14} /> : <IconShieldCheck size={14} />}
                                                                </button>
                                                            )}

                                                        </div>
                                                    ) : <span className="text-muted small">—</span>}
                                                </td>

                                                <td>
                                                    <div className="text-muted small">{form.userName || 'N/A'}</div>
                                                </td>

                                                <td>
                                                    <div className="small text-muted">{formatToIST(form?.updatedAt).split(',')[0]}</div>
                                                </td>
                                                <td className="px-4">
                                                    <div className="d-flex justify-content-end align-items-center gap-2">
                                                        {userRole === 'manager' && (form.status === 'MANAGER' || form.status === 'PENDING_MANAGER' || form.status === 'pending') && form.managerId === cookie.get('user-id') && (
                                                            <>
                                                                <Button 
                                                                    variant="success" 
                                                                    size="sm" 
                                                                    className="d-inline-flex align-items-center gap-1 px-3 py-1 fw-semibold shadow-sm"
                                                                    style={{ fontSize: '13px', borderRadius: '8px' }}
                                                                    title="Approve Form"
                                                                    onClick={(e) => { e.stopPropagation(); initiateStatusChange(form._id, form.formName, 'approved'); }}
                                                                >
                                                                    <IconCheck size={16} /> Approve
                                                                </Button>
                                                                <Button 
                                                                    variant="outline-danger" 
                                                                    size="sm" 
                                                                    className="d-inline-flex align-items-center gap-1 px-3 py-1 fw-semibold shadow-sm"
                                                                    style={{ fontSize: '13px', borderRadius: '8px' }}
                                                                    title="Reject Form"
                                                                    onClick={(e) => { e.stopPropagation(); initiateStatusChange(form._id, form.formName, 'rejected'); }}
                                                                >
                                                                    <IconX size={16} /> Reject
                                                                </Button>
                                                            </>
                                                        )}
                                                        
                                                        <Button 
                                                            variant="outline-primary" 
                                                            size="sm" 
                                                            className="d-inline-flex align-items-center gap-1 px-3 py-1 fw-semibold shadow-sm"
                                                            style={{ fontSize: '13px', borderRadius: '8px', background: '#eff6ff' }}
                                                            title="Download PDF"
                                                            onClick={(e) => { e.stopPropagation(); handleDownload(form._id, form?.formName, form?.userName); }}
                                                            disabled={downloadInProgress === form._id}
                                                        >
                                                            {downloadInProgress === form._id ? <IconLoader2 className="animate-spin" size={16} /> : <IconDownload size={16} />}
                                                            <span>PDF</span>
                                                        </Button>

                                                        <Button 
                                                            variant="outline-secondary" 
                                                            size="sm" 
                                                            className="d-inline-flex align-items-center gap-1 px-3 py-1 fw-semibold shadow-sm"
                                                            style={{ fontSize: '13px', borderRadius: '8px', color: '#1e293b', borderColor: '#cbd5e1', background: '#f8fafc' }}
                                                            title="View Form"
                                                            onClick={(e) => { e.stopPropagation(); handleFormClick(form); }}
                                                            disabled={!form._id}
                                                        >
                                                            <IconEye size={16} />
                                                            <span>View</span>
                                                        </Button>

                                                        {(userRole === 'admin' || userRole === 'engineer' || userRole === 'manager') && (
                                                            <Button 
                                                                variant="outline-danger" 
                                                                size="sm" 
                                                                className="d-inline-flex align-items-center gap-1 px-3 py-1 fw-semibold shadow-sm"
                                                                style={{ fontSize: '13px', borderRadius: '8px', background: '#fef2f2' }}
                                                                title="Delete Form"
                                                                onClick={(e) => { e.stopPropagation(); initiateDeleteForm(form._id, form.formName); }}
                                                                disabled={deleteInProgress === form._id}
                                                            >
                                                                <IconTrash size={16} />
                                                                <span>Delete</span>
                                                            </Button>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center py-5 text-muted border-0">
                                            <div className="py-4">
                                                <IconBox size={48} className="mb-3 opacity-20" />
                                                <p className="fw-bold mb-0">No forms found for this station</p>
                                                <p className="small text-muted">Initialize a new checklist or change filters</p>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                        {totalFormsCount > 0 && (
                            <div className="mt-4 d-flex justify-content-end">
                                <Pagination
                                    total={totalFormsCount}
                                    handlePageClick={handlePageClick}
                                    currentPage={currentPage}
                                    limit={limit}
                                    totalPages={totalPagesCount}
                                />
                            </div>
                        )}
                    </div>
                )}

                {/* Status Change Confirmation Modal */}
                <Modal show={showStatusModal} onHide={handleCloseStatusModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm Status Change</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Are you sure you want to {statusLabel(selectedStatus)} this form?</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseStatusModal}>
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            onClick={handleStatusChange}
                            disabled={statusChangeInProgress === selectedFormId}
                        >
                            {statusChangeInProgress === selectedFormId ? (
                                <>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className="me-2"
                                    />
                                    Changing...
                                </>
                            ) : (
                                'Confirm'
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Delete Confirmation Modal */}
                <Modal show={showDeleteModal} onHide={handleCloseDeleteModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm Delete</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>{`Are you sure you want to delete the form "${prettifyFormName(formName)}"? What you've done cannot be undone.`}</div>
                        <div className="mt-3 text-start">
                             <Form.Label className="small text-muted fw-bold mb-1" style={{ fontSize: '11px' }}>{`Type "DELETE" to confirm:`}</Form.Label>
                            <Form.Control
                                type="text"
                                className="text-center fw-bold"
                                value={deleteConfirmInput}
                                onChange={(e) => setDeleteConfirmInput(e.target.value)}
                                placeholder="DELETE"
                                style={{ letterSpacing: '2px' }}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseDeleteModal}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={handleDeleteForm} disabled={deleteInProgress === selectedFormId || deleteConfirmInput !== 'DELETE'}>
                            {deleteInProgress === selectedFormId ? (
                                <>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className="me-2"
                                    />
                                    Deleting...
                                </>
                            ) : (
                                'Delete'
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* ✅ Send to Contractor Modal (RESTORING) */}
                <Modal show={showContractorModal} onHide={() => setShowContractorModal(false)} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Contractor Assignment</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="mb-2">
                            <strong>Form:</strong> {prettifyFormName(formName)} &nbsp;|&nbsp; <strong>Level:</strong>{' '}
                            {contractorLevel === 'root' ? 'ROOT' : String(contractorLevel || '').toUpperCase()}
                        </div>
                        {(() => {
                            // Find the current form
                            const currentForm = stationwiseformslist.find(f => f._id === selectedFormId);
                            if (!currentForm) return <div>Form not found</div>;

                            const levelData = contractorLevel === 'root' ? currentForm : currentForm[contractorLevel];
                            const isAssigned = levelData?.contractorId;
                            const assignedContractor = isAssigned ? contractors.find(c => (c.id || c._id) === levelData.contractorId) : null;
                            const assignedAt = levelData?.contractorAssignedAt ? formatToIST(levelData.contractorAssignedAt) : null;

                            if (isAssigned && assignedContractor) {
                                return (
                                    <div className="premium-card p-3 border-0" style={{ background: 'rgba(255,255,255,0.05)', borderRadius: '12px' }}>
                                        <h5 className="mb-3" style={{ color: '#2563eb' }}>Assigned Contractor</h5>
                                        <div className="d-flex align-items-center mb-3">
                                            <div className="avatar me-3 bg-primary text-white rounded-circle d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }}>
                                                {assignedContractor.name?.charAt(0) || 'C'}
                                            </div>
                                            <div>
                                                <div className="fw-bold">{assignedContractor.name || `${assignedContractor.firstName || ''} ${assignedContractor.lastName || ''}`.trim()}</div>
                                                <div className="small text-muted">{assignedContractor.email}</div>
                                            </div>
                                        </div>
                                        {assignedAt && (
                                            <div className="small border-top pt-2 mt-2">
                                                <span className="text-muted">Assigned On:</span> <span className="fw-bold">{assignedAt}</span>
                                            </div>
                                        )}
                                    </div>
                                );
                            } else {
                                return (
                                    <Form.Group>
                                        <Form.Label>Select Contractor</Form.Label>
                                        <Select
                                            options={[...contractors]
                                                .sort((a, b) => {
                                                    const nameA = (a.name || `${a.firstName || ''} ${a.lastName || ''}`).trim().toLowerCase();
                                                    const nameB = (b.name || `${b.firstName || ''} ${b.lastName || ''}`).trim().toLowerCase();
                                                    return nameA.localeCompare(nameB);
                                                })
                                                .map((u) => ({
                                                    value: u.id || u._id,
                                                    label: `${u.name || `${u.firstName || ''} ${u.lastName || ''}`.trim()} (${u.email})`
                                                }))
                                            }
                                            value={selectedContractorId ? {
                                                value: selectedContractorId,
                                                label: contractors.find(c => (c.id || c._id) === selectedContractorId)?.name || `${contractors.find(c => (c.id || c._id) === selectedContractorId)?.firstName || ''} ${contractors.find(c => (c.id || c._id) === selectedContractorId)?.lastName || ''}`.trim() + ` (${contractors.find(c => (c.id || c._id) === selectedContractorId)?.email})`
                                            } : null}
                                            onChange={(selectedOption) => setSelectedContractorId(selectedOption ? selectedOption.value : '')}
                                            placeholder="-- Choose a contractor --"
                                            isClearable
                                        />
                                        <Form.Text className="text-muted small mt-2 d-block">
                                            Only users with the <strong>Contractor</strong> role are listed here.
                                        </Form.Text>
                                    </Form.Group>
                                );
                            }
                        })()}
                    </Modal.Body>
                    <Modal.Footer>
                        {(() => {
                            const currentForm = stationwiseformslist.find(f => f._id === selectedFormId);
                            const levelData = contractorLevel === 'root' ? currentForm : currentForm?.[contractorLevel];
                            const isAssigned = levelData?.contractorId;

                            if (!isAssigned) {
                                return (
                                    <>
                                        <Button variant="secondary" onClick={() => setShowContractorModal(false)}>
                                            Cancel
                                        </Button>
                                        <Button 
                                            variant="primary" 
                                            onClick={handleAssignToContractor} 
                                            disabled={assignInProgress || !selectedContractorId}
                                            style={{ background: '#2563eb', border: 'none' }}
                                        >
                                            {assignInProgress ? (
                                                <><IconLoader2 className="animate-spin me-2" /> Sending...</>
                                            ) : (
                                                'Send Assignment'
                                            )}
                                        </Button>
                                    </>
                                );
                            } else {
                                return (
                                    <Button variant="secondary" onClick={() => setShowContractorModal(false)}>
                                        Close
                                    </Button>
                                );
                            }
                        })()}
                    </Modal.Footer>
                </Modal>

                {/* ✅ Assign to Manager Modal */}
                <Modal show={showManagerModal} onHide={() => setShowManagerModal(false)} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Manager Assignment</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="mb-2">
                            <strong>Form:</strong> {prettifyFormName(formName)} &nbsp;|&nbsp; <strong>Level:</strong>{' '}
                            {managerLevel === 'root' ? 'ROOT' : String(managerLevel || '').toUpperCase()}
                        </div>
                        {(() => {
                            const currentForm = stationwiseformslist.find(f => f._id === selectedFormId);
                            if (!currentForm) return <div>Form not found</div>;

                            const levelData = managerLevel === 'root' ? currentForm : currentForm[managerLevel];
                            const isAssigned = levelData?.managerId;
                            const assignedManager = isAssigned ? managers.find(m => (m.id || m._id) === levelData.managerId) : null;
                            const assignedAt = levelData?.managerAssignedAt ? formatToIST(levelData.managerAssignedAt) : null;

                            if (isAssigned && assignedManager) {
                                return (
                                    <div className="premium-card p-3 border-0" style={{ background: 'rgba(255,255,255,0.05)', borderRadius: '12px' }}>
                                        <h5 className="mb-3" style={{ color: '#2563eb' }}>Assigned Manager</h5>
                                        <div className="d-flex align-items-center mb-3">
                                            <div className="avatar me-3 bg-success text-white rounded-circle d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }}>
                                                {assignedManager.name?.charAt(0) || 'M'}
                                            </div>
                                            <div>
                                                <div className="fw-bold">{assignedManager.name || `${assignedManager.firstName || ''} ${assignedManager.lastName || ''}`.trim()}</div>
                                                <div className="small text-muted">{assignedManager.email}</div>
                                            </div>
                                        </div>
                                        {assignedAt && (
                                            <div className="small border-top pt-2 mt-2">
                                                <span className="text-muted">Assigned On:</span> <span className="fw-bold">{assignedAt}</span>
                                            </div>
                                        )}
                                    </div>
                                );
                            } else {
                                return (
                                    <Form.Group>
                                        <Form.Label>Select Manager</Form.Label>
                                        <Form.Select
                                            value={selectedManagerId}
                                            onChange={(e) => setSelectedManagerId(e.target.value)}
                                        >
                                            <option value="">Choose a manager</option>
                                            {managers.map((u) => (
                                                <option key={u.id || u._id} value={u.id || u._id}>
                                                    {u.name || `${u.firstName || ''} ${u.lastName || ''}`.trim()} ({u.email})
                                                </option>
                                            ))}
                                        </Form.Select>
                                        <Form.Text className="text-muted small mt-2 d-block">
                                            Only users with the <strong>Manager</strong> role are listed here.
                                          </Form.Text>
                                    </Form.Group>
                                );
                            }
                        })()}
                    </Modal.Body>
                    <Modal.Footer>
                        {(() => {
                            const currentForm = stationwiseformslist.find(f => f._id === selectedFormId);
                            const levelData = managerLevel === 'root' ? currentForm : currentForm?.[managerLevel];
                            const isAssigned = levelData?.managerId;

                            if (!isAssigned) {
                                return (
                                    <>
                                        <Button variant="secondary" onClick={() => setShowManagerModal(false)}>
                                            Cancel
                                        </Button>
                                        <Button 
                                            variant="primary" 
                                            onClick={handleAssignToManager} 
                                            disabled={managerAssignInProgress || !selectedManagerId}
                                            style={{ background: '#2563eb', border: 'none' }}
                                        >
                                            {managerAssignInProgress ? (
                                                <><IconLoader2 className="animate-spin me-2" /> Assigning...</>
                                            ) : (
                                                'Assign Manager'
                                            )}
                                        </Button>
                                    </>
                                );
                            } else {
                                return (
                                    <Button variant="secondary" onClick={() => setShowManagerModal(false)}>
                                        Close
                                      </Button>
                                );
                            }
                        })()}
                    </Modal.Footer>
                </Modal>



                {/* Edit Station Details Modal */}
                <Modal show={showEditStationModal} onHide={() => setShowEditStationModal(false)} centered>
                    <Modal.Header closeButton>
                        <Modal.Title className="d-flex align-items-center gap-2">
                            <IconEdit size={22} className="text-primary" /> Edit Station Details
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {editStationError && (
                            <Alert variant="danger" className="mb-3 py-2 px-3">
                                {editStationError}
                            </Alert>
                        )}
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-semibold">Station Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter station name..."
                                value={editStationName}
                                onChange={(e) => setEditStationName(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-semibold">Station ID</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter station ID..."
                                value={editStationId}
                                onChange={(e) => setEditStationId(e.target.value)}
                            />
                            <Form.Text className="text-muted small">
                                Note: Updating the Station ID will sync all forms for this station and update the station route.
                            </Form.Text>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowEditStationModal(false)}>
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            onClick={handleSaveStationDetails}
                            disabled={editStationLoading}
                            style={{ background: '#2563eb', border: 'none' }}
                        >
                            {editStationLoading ? (
                                <><IconLoader2 className="animate-spin me-2" size={18} /> Saving...</>
                            ) : (
                                'Save Changes'
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Add Forms Modal (unchanged) */}
                <Modal show={showAddFormsModal} onHide={handleAddFormsModalClose} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Add Forms to Station: {stationId}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {addFormError && (
                            <Alert variant="danger" className="mb-3">
                                {addFormError}
                            </Alert>
                        )}
                        <ListGroup>
                            {checklistItems.map((item) => (
                                <ListGroup.Item key={item} className="d-flex align-items-center">
                                    <span className="flex-grow-1">{item}</span>
                                    <InputGroup style={{ width: '150px' }}>
                                        <Button
                                            variant="outline-secondary"
                                            onClick={() => adjustQuantity(item, -1)}
                                            disabled={quantities[item] === 0}
                                        >
                                            −
                                        </Button>
                                        <Form.Control
                                            type="number"
                                            value={quantities[item]}
                                            min={0}
                                            onChange={(e) => handleQuantityChange(item, e.target.value)}
                                            style={{ textAlign: 'center' }}
                                        />
                                        <Button variant="outline-secondary" onClick={() => adjustQuantity(item, 1)}>
                                            +
                                        </Button>
                                    </InputGroup>
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleAddFormsModalClose}>
                            Cancel
                        </Button>
                        <Button variant="success" onClick={handleAddFormsSubmit}>
                            Send
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    );
};

export default StationForms;
